import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-rewards-digital',
  templateUrl: './rewards-digital.component.html',
  styleUrls: ['./rewards-digital.component.scss']
})
export class RewardsDigitalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
